/**
 * AM Protected Route
 * 
 * Route guard for Account Manager pages.
 * Allows access for account_manager and admin roles.
 */

import { Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { useAdmin } from "@/hooks/useAdmin";
import { useAccountManager } from "@/hooks/useAccountManager";

interface AMProtectedRouteProps {
  children: React.ReactNode;
}

export function AMProtectedRoute({ children }: AMProtectedRouteProps) {
  const { session, loading: authLoading } = useAuth();
  const { role, isAccountManager: isAMRole, loading: adminLoading } = useAdmin();
  const { isAccountManager: hasAMProfile, loading: amLoading } = useAccountManager();

  if (authLoading || adminLoading || amLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-pulse text-muted-foreground">Loading...</div>
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/login" replace />;
  }

  // Allow: admins, users with account_manager role, or users with an AM profile
  if (role !== "admin" && !isAMRole && !hasAMProfile) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
